// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.l6K46LTZ66mLrs {
  grid-area: cvv;
}
.bpBCZAPa_AWAwT {
  margin: var(--ds-space-0, 0) var(--ds-space-0, 0) var(--ds-space-0, 0) var(--ds-space-050, 4px);
  padding: var(--ds-space-0, 0);
}
.bpBCZAPa_AWAwT:focus {
  outline: 2px solid var(--ds-border-focused, #388bff);
}
.gK18t7vg6z5d_q {
  margin-bottom: var(--ds-space-250, 20px);
}
.gK18t7vg6z5d_q:last-child {
  margin: var(--ds-space-0, 0);
}
.gK18t7vg6z5d_q h4 {
  font-size: 14px;
}
.gK18t7vg6z5d_q p {
  font-size: 12px;
}
.gK18t7vg6z5d_q .Vr5IhutWTiubCV {
  max-width: 100%;
}
`, ""]);
// Exports
export var container = `l6K46LTZ66mLrs`;
export var help = `bpBCZAPa_AWAwT`;
export var cardExample = `gK18t7vg6z5d_q`;
export var preview = `Vr5IhutWTiubCV`;
export default ___CSS_LOADER_EXPORT___;
